import React from 'react';

import withLazyLoad from 'utils/withLazyLoad';
import withPid from 'utils/withPid';
import AboutPage, { IAboutPageProps } from '../../components/AboutPage';

import TigerSharesLogo from '../../images/TIGERSHARES-logo.png';

const TigerSharesConfig: IAboutPageProps = {
    title: 'TIGERSHARES',
    header: <img className="mb-3 img-title" src={TigerSharesLogo} alt="TIGERSHARES" />,
    paragraph: [
        'Advertising services; Business organization consultancy; Business appraisals;',
        'Market analysis; Commercial and industrial management assistance; Business efficiency expert services; Marketing services; Sales promotion for others;',
        'Import-export agency services; Telemarketing services; Personnel management consultancy; Compilation of information into computer databases'
    ],
    noMarginTop: true
};

const TigerShares: React.FC = () => {
    return <AboutPage {...TigerSharesConfig} />;
};

export default withLazyLoad(withPid('brand')(TigerShares));
